<template>
  <tr>
    <td>{{ school.localCode }}</td>
    <td class="border-right has-text-weight-bold" :title="school.locationName">
      {{school.locationName}}
    </td>
    <td class="border-right nowrap"><span>{{ school.currentBaseYear }}</span></td>
    <td>{{ school.baseYearTotalIdentified }}</td>
    <td>{{ school.baseYearTotalEnrolled }}</td>
    <td class="border-right nowrap">{{ school.baseYearISP }}</td>
    <td class="border-right"></td>
    <td>{{ school.identifiedCount }}</td>
    <td>{{school.enrolledCount }}</td>
    <td class="border-right nowrap">
      {{ typeof school.totalISP === 'number' ? school.totalISP.toFixed(2) : '--'}}
      <es-trend-indicator :prevISP="school.prevYearISP" :currentISP="school.totalISP"/>
    </td>
    <td class="border-right">{{ school.prevYearParticipation }}</td>
    <td>
      <div class="select">
        <select
          :disabled="
            loading
            || districtWide
            || school.approvalStatus === 'A'
            || viewOnly"
          class="select-box-small"
          @change="updateParticipation($event, school)"
          v-model="selectedParticipation">
          <option value="undefined" disabled selected hidden>Select decision</option>
          <option
            v-for="(cluster) in permissibleClusters"
            :key="cluster.clusterId"
            :value="cluster.clusterId">
            {{ districtWide ? "Individual Participation" : cluster.cluster.description }}
          </option>
        </select>
      </div>
    </td>
  </tr>
</template>

<script>
import EsTrendIndicator from '@/components/EsTrendIndicator.vue';
import NotificationManager from '@/mixins/NotificationManager';

export default {
  mixins: [
    NotificationManager,
  ],
  components: {
    EsTrendIndicator,
  },
  props: {
    availableClusters: {
      type: Array,
      required: true,
    },
    cepSummary: {
      type: Object,
    },
    districtWide: {
      type: Boolean,
      required: true,
    },
    loading: {
      type: Boolean,
    },
    locationGroupId: {
      required: true,
    },
    school: {
      type: Object,
      required: true,
    },
    viewOnly: {
      type: Boolean,
    },
  },
  data() {
    return {
      permissibleClusters: [],
      selectedParticipation: null,
    };
  },
  watch: {
    availableClusters() {
      this.setPermissibleClusters();
    },
    school() {
      this.selectedParticipation = this.getSelectedParticipation();
    },
  },
  created() {
    this.setPermissibleClusters();
    this.selectedParticipation = this.getSelectedParticipation();
  },
  methods: {
    getSelectedParticipation() {
      if (this.school.clusterId) {
        return this.school.clusterId;
      }

      return this.school.participationDecision;
    },
    setPermissibleClusters() {
      const clusters = [...this.availableClusters];

      if (this.school.individualParticipationReady) {
        clusters.push({ clusterId: 'Y', cluster: { description: 'Individual Participation', clusterNum: 'Y' } });
      }

      clusters.push({ clusterId: 'N', cluster: { description: 'Not Participating', clusterNum: 'N' } });
      this.permissibleClusters = clusters;
    },
    async updateParticipation() {
      this.$emit('refreshRecalculate', {
        stateLocationId: this.school.stateLocationId,
        selectedCluster: this.permissibleClusters.find(
          c => c.clusterId === this.selectedParticipation,
        ),
      });
    },
  },
};
</script>

<style lang="sass" scoped>
  .border-right
    border-right: 1px solid #dee2e6
  .table tbody tr td
    padding: .1rem 0.75rem
  .select
    max-width: auto
    width: 100%
    select
      max-width: auto
      width: 100%
</style>
